module.exports = __webpack_public_path__ + "static/media/201CS101.81da0ba2.jpg";